import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getFabricClass,
  addFabricClass,
  deleteFabricClass,
  updateFabricClass,
} from "../../redux/actions/FabricClass.action";

import { getLog } from "../../redux/actions/log.action";
import { getRights } from "../../redux/actions/userRights.action";

import PageHeader from "../../components/PageHeader/PageHeader";
import CrudButtons from "../../components/CrudButtons/CrudButtons";
import { ReadCookie } from "../../utils/readCookie";
import Tables from "../../components/Table/Tables";
import { Button, Row, Col, Form, Input, Checkbox, Tabs, Divider } from "antd";

import { logColumns, fabricClassColumns } from "../../utils/cols";
import notification from "../../utils/notification";
import "../Style/style.css";
import { TabTitle } from "../../utils/GeneralFunction";
const { TabPane } = Tabs;
export default function FabricClass({ token }) {
  TabTitle("Fabric Class")
  const menuId = ReadCookie("menuId");

  const FabricClassNameInput = useRef(null);
  const [form] = Form.useForm();
  const [fabricClassObj, setFabricClassObj] = useState(null);
  const dispatch = useDispatch();
  const { fabricClass, log, userRights } = useSelector((state) => state);
  const [minimize, setMinimize] = useState(false);
  const [check, setCheck] = useState(false);
  const [fabricClassName, setFabricClassName] = useState("");
  const [disable, setDisable] = useState(false);
  const [formState, setFormState] = useState("view");

  useEffect(() => {
    dispatch(getFabricClass(token, menuId));
    // dispatch(getLog(token));
    dispatch(getLog(token, { inv_fabric_class: "inv_fabric_class"}))
  }, [token]);

  useLayoutEffect(() => {
    dispatch(getRights(token, menuId)).then((res) => {
      if (res.type === "GET_USER_RIGHTS_SUCCESS") {
        if (!res?.payload.can_add) {
          setFormState("table");
        }
      }
    });
  }, []);

  useEffect(() => {
    if (fabricClassObj) {
      setFormState("view");
      form.setFieldsValue({
        id: fabricClassObj.fabric_class_id,
        fabricClass: fabricClassObj.fabric_class_name,
        active: fabricClassObj.is_active,
      });
      setFabricClassName(fabricClassObj.fabric_class_name);
      setCheck(fabricClassObj.is_active);
    }
  }, [fabricClassObj]);

  useEffect(() => {
    if (fabricClassName === "") {
      setDisable(true);
    } else {
      setDisable(false);
    }
  }, [fabricClassName]);

  const handleTab = (key) => {
    if (key === "logs") {
      dispatch(
        getLog(token, {
          inv_fabric_class: "inv_fabric_class",
          admin_company_entity_access: "admin_company_entity_access",
        })
      );
    }
  };

  const formSave = () => {
    if (formState === "add") {
      dispatch(addFabricClass(token, { fabricClassName, check }, menuId)).then(
        (res) => {
          if (res.type === "ADD_FABRICCLASS_ERROR") {
            notification(
              "error",
              res?.payload?.request?.statusText,
              res?.payload?.data?.data
            );
          }
          if (res.type === "ADD_FABRICCLASS_SUCCESS") {
            notification(
              "success",
              "Fabric Class Created",
              "Record updated successfully"
            );
               form.setFieldsValue({
              fabricClass: ""
          })
          setFormState("")
          // setCheck(false)
          setFabricClassName("")
          setFabricClassObj(null)
          }
          dispatch(getFabricClass(token));
        }
      );
    }

    if (formState === "edit") {
      dispatch(
        updateFabricClass(
          token,
          { fabricClassName, check },
          fabricClassObj.fabric_class_id
        )
      ).then((res) => {
        if (res.type === "UPDATE_FABRICCLASS_ERROR") {
          notification("error", "Update", "Something went wrong");
        }
        if (res.type === "UPDATE_FABRICCLASS_SUCCESS") {
          notification(
            "success",
            "Fabric Class Updated",
            "Record updated successfully"
          );
        }
        dispatch(getFabricClass(token));
      });
    }
  };

  const handleDelete = () => {
    if (fabricClassObj) {
      dispatch(deleteFabricClass(token, fabricClassObj.fabric_class_id)).then(
        (res) => {
          if (res.type === "DELETE_FABRICCLASS_SUCCESS") {
            notification(
              "success",
              "Fabric Class Deleted",
              "FabricClass deleted successfully!"
            );
          }
          if (res.type === "DELETE_FABRICCLASS_ERROR") {
            notification(
              "error",
              res?.payload?.request?.statusText,
              res?.payload?.data?.data
            );
          }
          form.setFieldsValue({
            fabricClass: "",
          });
          // setCheck(false)
          setFabricClassName("");
          setFabricClassObj(null);
          setFormState("");
          dispatch(getFabricClass(token));
        }
      );
    }
  };

  useEffect(() => {
    if (formState === "add") {
       
        FabricClassNameInput.current.focus();
        form.setFieldsValue({
            fabricClass: ""
        })
        setCheck(true)
        setFabricClassName("")
        setFabricClassObj(null)
    }
}, [formState]);


  const filterReset = () => {
    setFormState("view");
  };

  return (
    <div className="styleContainer">
      <div className="styleBody h-100">
        <PageHeader
          title={"Fabric Class"}
          minimize={setMinimize}
          check={minimize}
        />
        {!minimize && (
          <div className="bodyStyle">
            <div className="crudDiv">
              <CrudButtons
                rights={userRights?.payload}
                reset={filterReset}
                formType={formState}
                save={formSave}
                disable={disable}
                formState={setFormState}
                onDelete={handleDelete}
              />
            </div>

            <div className="styleContent">
              <Row className="tables-main-row-new">
                <Col xs={24} sm={24} md={10} lg={8} xl={6}>
                  <div className="styleTable">
                    <Tables
                      type="fabricClass"
                      fabricClassObj={setFabricClassObj}
                      scrollX={"20rem"}
                      scroll={602}
                      perPage={25}
                      source={fabricClass?.payload?.data}
                      col={fabricClassColumns}
                      paginate
                      load={fabricClass.loading}
                    />
                  </div>
                </Col>
                <Col xs={24} sm={24} md={14} lg={16} xl={18}>
                  <div className="styleForm">
                    <Form form={form} name="basic" labelCol={{ span: 8 }}>
                      <div className="customRow styleFormUpper ">
                        {fabricClassObj !== null && !(formState === "add") && (
                          <div className="customCols slc">
                            <Form.Item
                              label="ID"
                              name="id"
                              initialValue={form.getFieldValue().id}
                              labelCol={{ span: 10 }}
                              wrapperCol={{ span: 14 }}
                            >
                              <Input
                                size="small"
                                className="styleInput id-field-style"
                                readOnly
                              />
                            </Form.Item>
                          </div>
                        )}
                        <div className="customCols slc">
                          <Form.Item
                            label="Fabric Class"
                            name="fabricClass"
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 14 }}
                            initialValue={form.getFieldValue().style}
                          >
                            <Input
                              size="small"
                              // placeholder="Fabric Class Name"
                              disabled={
                                !(formState === "add" || formState === "edit")
                              }
                              ref={FabricClassNameInput}
                              onChange={(e) =>
                                setFabricClassName(e.target.value)
                              }
                              className="styleInput"
                            />
                          </Form.Item>
                        </div>
                        <div className="customCols slc">
                          <Form.Item
                            label="Active"
                            name="active"
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 14 }}
                          >
                            <Checkbox
                              disabled={
                                !(formState === "add" || formState === "edit")
                              }
                              checked={check}
                              onChange={(e) => setCheck(e.target.checked)}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </Form>
                    <Divider />
                    <div className="styleTab">
                      <Tabs
                        type="card"
                        tabBarGutter={2}
                        defaultActiveKey="1"
                        centered
                        onChange={(key) => handleTab(key)}
                      >
                        <TabPane tab="Log Info" key="logs">
                          <div className="tabs">
                            <Tables
                              type="company"
                              scrollX={"50rem"}
                              scroll={360}
                              perPage={15}
                              source={log?.payload?.data}
                              col={logColumns}
                              load={log.loading}
                              paginate
                            />
                          </div>
                        </TabPane>
                      </Tabs>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        )}
      </div>
      {minimize && (
        <div className="styleFooter">
          <Button
            className="minimize-button-style"
            onClick={() => setMinimize(false)}
          >
            Style
          </Button>
        </div>
      )}
    </div>
  );
}
